import { Box, Button, Checkbox, Divider, Grid, Tooltip, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import { otherSettingsType } from '../types';

export const useOtherSettings = () => {
  const [otherSettings, setOtherSettings] = useState<otherSettingsType>({ shareWithClient: false });
  return {
    OtherSettingsComponents,
    otherSettings,
    setOtherSettings,
  };
};

type Props = {
  setOtherSettings: React.Dispatch<React.SetStateAction<otherSettingsType>>;
  otherSettings: otherSettingsType;
};

const OtherSettingsComponents: FC<Props> = ({ otherSettings, setOtherSettings }) => {
  const { t } = useTranslation();
  const [isCollapseOpen, setIsCollapseOpen] = useState<boolean>(false);

  return (
    <>
      <Divider style={{ margin: '16px 0 16px 0' }} />

      <Box style={{ marginTop: '16px' }}>
        <Button
          onClick={() => setIsCollapseOpen(!isCollapseOpen)}
          style={{ background: 'none', border: 'none', padding: 0, margin: 0, color: '#000' }}
        >
          <span style={{ color: '#444' }}>{isCollapseOpen ? `▼  ` : `▶  `}</span>
          <Typography style={{ fontSize: '12pt', color: '#444' }}>
            {t('pages.alerts.addNewAlert.otherSettings')}
          </Typography>
        </Button>
        {isCollapseOpen && (
          <Box style={{ padding: '12px' }}>
            <Box>
              <Grid container spacing={1}>
                <Grid item xs={8}>
                  <Typography style={{ fontSize: '11pt', color: '#444' }}>
                    {t('pages.alerts.addNewAlert.shareInClient')}
                    <Tooltip title={t('pages.alerts.tooltip.shareWithClientTooltip')}>
                      <HelpOutlineIcon
                        style={{ cursor: 'pointer', marginLeft: 2, fontSize: '14px' }}
                      />
                    </Tooltip>
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Checkbox
                    onClick={() => {
                      setOtherSettings({
                        ...otherSettings,
                        shareWithClient: !otherSettings.shareWithClient,
                      });
                    }}
                    checked={otherSettings.shareWithClient}
                    style={{ padding: 0, margin: 0 }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};
